import {VirtualHost} from "../../constants";

export let ef = "EFATURA";
export let ea = "EARSIV";
export let eb = "EBELGE";

export let earsiv = {
    gibType: ea,
    invoiceTypeInfo: {
        invoiceTypeCode: "SATIS",
        profileId: "EARSIVFATURA",
        accountingCost: null
    }
};

export let efatura = {
    gibType: ef,
    invoiceTypeInfo: {
        invoiceTypeCode: "SATIS",
        profileId: "TEMELFATURA",
        accountingCost: null
    }
};

export function isEfatura(type) {
    return type.gibType === ef;
}

export function isEarsiv(type) {
    return type.gibType === ea;
}

export function isEBelge(type) {
    return type.gibType === eb;
}

export function predefinedButtonFilter(predefined, newPreDefined, type) {

    let prefixValid = false;
    if(["EFATURA","EARSIVFATURA"].includes(type) &&  ["EFATURA","EARSIV"].includes(predefined.gibType)){
        prefixValid = (newPreDefined["ea_" + predefined.value] || newPreDefined["ef_" + predefined.value]);
    }else if(type === predefined.gibType){
        prefixValid = newPreDefined["eb_" + predefined.value];
    }
    if (prefixValid){
        if (predefined.includePortalTypes.includes(VirtualHost.conf.resourcePrefix)) {
            return true;
        } else if (predefined.excludePortalTypes.includes(VirtualHost.conf.resourcePrefix)) {
            return false;
        } else if (predefined.includePortalTypes.includes("all")) {
            return true;
        } else if (predefined.excludePortalTypes.includes("all")) {
            return false;
        }
    }
    return false;
}

export let predefinedInvoiceTypes = [
    {
        gibType: ef,
        value: "SGK",
        label: "SGK Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SGK",
            profileId: "TEMELFATURA",
            accountingCost: "SAGLIK_ECZ"
        },
        includePortalTypes: ["eczacikart", "farmakom", "smart", "kolaysoft", "hizli","medikal", "isitmemerkezi", "testud", "mbtfatura"],
        excludePortalTypes: ["masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ef,
        value: "SGK_OPT",
        label: "SGK Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SGK",
            profileId: "TEMELFATURA",
            accountingCost: "SAGLIK_OPT"
        },
        includePortalTypes: ["togb"],
        excludePortalTypes: ["masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ef,
        value: "DEPO_IADE",
        label: "Depo iade Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "IADE",
            profileId: "TEMELFATURA",
            accountingCost: null
        },
        includePortalTypes: ["eczacikart", "smart", "kolaysoft", "hizli", "farmakom"],
        excludePortalTypes: ["all"]
    },
    {
        gibType: ef,
        value: "GOC",
        label: "Göç İdaresi Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "TEMELFATURA",
            accountingCost: null
        },
        includePortalTypes: ["eczacikart", "farmakom", "smart", "kolaysoft", "hizli", "medikal", "isitmemerkezi", "testud"],
        excludePortalTypes: ["all"]
    },
    {
        gibType: ef,
        value: "CETAS",
        label: "Ceza Evi Fatura (CETAS)",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "TEMELFATURA",
            accountingCost: null
        },
        includePortalTypes: ["eczacikart", "farmakom", "smart", "kolaysoft", "hizli", "togb", "medikal", "isitmemerkezi", "testud"],
        excludePortalTypes: ["all"]
    },
    {
        gibType: ef,
        value: "HalInvoice",
        label: "Hal Tipi E-Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "HKS",
            accountingCost: null
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["eczacikart", "medikal", "isitmemerkezi", "testud", "togb", "cicekfatura","masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ea,
        value: "HalEArchive",
        label: "Hal Tipi E-Arşiv",
        invoiceTypeInfo: {
            invoiceTypeCode: "HKSSATIS",
            profileId: "EARSIVFATURA",
            accountingCost: null,
            retailCustomer: false
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["eczacikart", "medikal", "isitmemerkezi", "testud", "togb", "cicekfatura","masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ef,
        value: "YOLCUBERABERFATURA",
        label: "Yolcu Beraber Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "ISTISNA",
            profileId: "YOLCUBERABERFATURA",
            accountingCost: null,
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["eczacikart", "medikal", "isitmemerkezi", "testud", "togb", "cicekfatura","masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ef,
        value: "Ihracat",
        label: "İhracat Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "ISTISNA",
            profileId: "IHRACAT",
            accountingCost: null
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["eczacikart", "medikal", "isitmemerkezi", "testud", "togb","masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ea,
        value: "Perakende",
        label: "Perakende Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "EARSIVFATURA",
            accountingCost: null,
            retailCustomer: true
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["eczacikart", "togb", "medikal", "isitmemerkezi", "testud"]
    },
    {
        gibType: ea,
        value: "HastaPerakende",
        label: "Hasta Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "EARSIVFATURA",
            accountingCost: null,
            retailCustomer: true
        },
        includePortalTypes: ["eczacikart", "togb", "medikal", "isitmemerkezi", "testud"],
        excludePortalTypes: ["masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ef,
        value: "CiroPrimi",
        label: "Ciro Primi Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "TEMELFATURA",
            accountingCost: null,
            invoiceLines: [{
                recordId: null,
                itemCode: null,
                buyersItemIdentification: null,
                manufacturersItemIdentification: null,
                itemId: null,
                itemName: "Ciro Primi",
                barcode: null,
                quantity: 1,
                unit: "C62",
                unitPrice: 1,
                lineExtensionAmount: 1,
                trdDocInvoiceLineCharges: [
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 5,
                            code: "0000",
                            shortName: "İSKONTO",
                            longName: "İSKONTO",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: -1,
                            affectTaxableAmount: 1,
                            mm: 0,
                            smm: 0,
                            inv: 1,
                            isAffectKdv: 1
                        },
                        direction: -1,
                        percentage: 0,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 1,
                            code: "0015",
                            shortName: "KDV GERCEK",
                            longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            direction: 1,
                            calculatedBy: "AMOUNT",
                            priority: 4,
                            affectTaxableAmount: 0,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        direction: 1,
                        percentage: 10,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0.10,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    }
                ],
                trdDocInvoiceLineDeliveryDetail: null,
            }
            ]
        },
        includePortalTypes: ["eczacikart", "kolaysoft"],
        excludePortalTypes: ["masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ef,
        value: "FiyatFarki",
        label: "Fiyat Farkı Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "TEMELFATURA",
            accountingCost: null,
            invoiceLines: [{
                recordId: null,
                itemCode: null,
                buyersItemIdentification: null,
                manufacturersItemIdentification: null,
                itemId: null,
                itemName: "Fiyat Farkı",
                barcode: null,
                quantity: 1,
                unit: "C62",
                unitPrice: 1,
                lineExtensionAmount: 1,
                trdDocInvoiceLineCharges: [
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 5,
                            code: "0000",
                            shortName: "İSKONTO",
                            longName: "İSKONTO",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: -1,
                            affectTaxableAmount: 1,
                            mm: 0,
                            smm: 0,
                            inv: 1,
                            isAffectKdv: 1
                        },
                        direction: -1,
                        percentage: 0,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 1,
                            code: "0015",
                            shortName: "KDV GERCEK",
                            longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            direction: 1,
                            calculatedBy: "AMOUNT",
                            priority: 4,
                            affectTaxableAmount: 0,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        direction: 1,
                        percentage: 10,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0.10,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    }
                ],
                trdDocInvoiceLineDeliveryDetail: null,
            }
            ]
        },
        includePortalTypes: ["eczacikart", "kolaysoft"],
        excludePortalTypes: ["masfed", "temfed","esnaffatura"]
    },
    {
        gibType: eb,
        value: "NakliyeEAFatura",
        label: "Nakliye Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "TEVKIFAT",
            documentTypeCode: "TEVKIFAT",
            profileId: "EBELGE",
            accountingCost: null,
            retailCustomer: false,
            trdDocBelgeLines: [
                {
                    recordId: null,
                    itemCode: null,
                    buyersItemIdentification: null,
                    manufacturersItemIdentification: null,
                    itemId: null,
                    itemName: "YÜK TAŞIMACILIĞI",
                    barcode: null,
                    quantity: 1,
                    unit: "C62",
                    unitPrice: 1,
                    lineExtensionAmount: 1,
                    trdDocBelgeLineCharges: [
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 5,
                                code: "0000",
                                shortName: "İSKONTO",
                                longName: "İSKONTO",
                                direction: -1,
                                calculatedBy: "AMOUNT",
                                priority: -1,
                                affectTaxableAmount: 1,
                                mm: 0,
                                smm: 0,
                                inv: 1,
                                isAffectKdv: 1
                            },
                            direction: -1,
                            percentage: 0,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0,
                            calculatedBy: "AMOUNT",
                            withholdingCode: null,
                            allowanceReason: null,
                        },
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 1,
                                code: "0015",
                                shortName: "KDV GERCEK",
                                longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                                direction: 1,
                                calculatedBy: "AMOUNT",
                                priority: 4,
                                affectTaxableAmount: 0,
                                mm: 0,
                                smm: 1,
                                inv: 1,
                                isAffectKdv: 0
                            },
                            direction: 1,
                            percentage: 20,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0.20,
                            calculatedBy: "AMOUNT",
                            withholdingCode: null,
                            allowanceReason: null,
                        },
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 6,
                                code: "9015",
                                shortName: "KDV TEVKİFATI",
                                longName: "KDV TEVKİFATI",
                                direction: -1,
                                calculatedBy: "AMOUNT",
                                priority: 5,
                                affectTaxableAmount: 0,
                                mm: 0,
                                smm: 1,
                                inv: 1,
                                isAffectKdv: 0
                            },
                            direction: -1,
                            percentage: 20,
                            priority:5,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0.04,
                            calculatedBy: "AMOUNT",
                            withholdingCode: "624",
                            allowanceReason: null,
                            calculateFrom:'withholdingCode',
                        }
                    ]
                }
            ]
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["masfed", "temfed"]
    },
    {
        gibType: eb,
        value: "Perakende",
        label: "Perakende Fatura",
        invoiceTypeInfo: {
            documentTypeCode: "SATIS",
            profileId: "EBELGE",
            accountingCost: null,
            retailCustomer: true
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["all"]
    },
    {
        gibType: eb,
        value: "ServisEAFatura",
        label: "Servis Taşımacılığı Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "TEVKIFAT",
            documentTypeCode: "TEVKIFAT",
            profileId: "EBELGE",
            accountingCost: null,
            retailCustomer: false,
            trdDocBelgeLines: [
                {
                    recordId: null,
                    itemCode: null,
                    buyersItemIdentification: null,
                    manufacturersItemIdentification: null,
                    itemId: null,
                    itemName: "SERVİS TAŞIMACILIĞI",
                    barcode: null,
                    quantity: 1,
                    unit: "C62",
                    unitPrice: 1,
                    lineExtensionAmount: 1,
                    trdDocBelgeLineCharges: [
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 5,
                                code: "0000",
                                shortName: "İSKONTO",
                                longName: "İSKONTO",
                                direction: -1,
                                calculatedBy: "AMOUNT",
                                priority: -1,
                                affectTaxableAmount: 1,
                                mm: 0,
                                smm: 0,
                                inv: 1,
                                isAffectKdv: 1
                            },
                            direction: -1,
                            percentage: 0,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0,
                            calculatedBy: "AMOUNT",
                            withholdingCode: null,
                            allowanceReason: null,
                        },
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 1,
                                code: "0015",
                                shortName: "KDV GERCEK",
                                longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                                direction: 1,
                                calculatedBy: "AMOUNT",
                                priority: 4,
                                affectTaxableAmount: 0,
                                mm: 0,
                                smm: 1,
                                inv: 1,
                                isAffectKdv: 0
                            },
                            direction: 1,
                            percentage: 20,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0.20,
                            calculatedBy: "AMOUNT",
                            withholdingCode: null,
                            allowanceReason: null,
                        },
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 6,
                                code: "9015",
                                shortName: "KDV TEVKİFATI",
                                longName: "KDV TEVKİFATI",
                                direction: -1,
                                calculatedBy: "AMOUNT",
                                priority: 5,
                                affectTaxableAmount: 0,
                                mm: 0,
                                smm: 1,
                                inv: 1,
                                isAffectKdv: 0
                            },
                            direction: -1,
                            percentage: 50,
                            priority:5,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0.09,
                            calculatedBy: "AMOUNT",
                            withholdingCode: "614",
                            allowanceReason: null,
                            calculateFrom:'withholdingCode',
                        }
                    ]
                }
            ]
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["masfed", "temfed"]
    },
    {
        gibType: eb,
        value: "TekstilEAFatura",
        label: "Tekstil Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "TEVKIFAT",
            documentTypeCode: "TEVKIFAT",
            profileId: "EBELGE",
            accountingCost: null,
            retailCustomer: false,
            trdDocBelgeLines: [
                {
                    recordId: null,
                    itemCode: null,
                    buyersItemIdentification: null,
                    manufacturersItemIdentification: null,
                    itemId: null,
                    itemName: "",
                    barcode: null,
                    quantity: 1,
                    unit: "C62",
                    unitPrice: 1,
                    lineExtensionAmount: 1,
                    trdDocBelgeLineCharges: [
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 5,
                                code: "0000",
                                shortName: "İSKONTO",
                                longName: "İSKONTO",
                                direction: -1,
                                calculatedBy: "AMOUNT",
                                priority: -1,
                                affectTaxableAmount: 1,
                                mm: 0,
                                smm: 0,
                                inv: 1,
                                isAffectKdv: 1
                            },
                            direction: -1,
                            percentage: 0,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0,
                            calculatedBy: "AMOUNT",
                            withholdingCode: null,
                            allowanceReason: null,
                        },
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 1,
                                code: "0015",
                                shortName: "KDV GERCEK",
                                longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                                direction: 1,
                                calculatedBy: "AMOUNT",
                                priority: 4,
                                affectTaxableAmount: 0,
                                mm: 0,
                                smm: 1,
                                inv: 1,
                                isAffectKdv: 0
                            },
                            direction: 1,
                            percentage: 20,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0.20,
                            calculatedBy: "AMOUNT",
                            withholdingCode: null,
                            allowanceReason: null,
                        },
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 6,
                                code: "9015",
                                shortName: "KDV TEVKİFATI",
                                longName: "KDV TEVKİFATI",
                                direction: -1,
                                calculatedBy: "AMOUNT",
                                priority: 5,
                                affectTaxableAmount: 0,
                                mm: 0,
                                smm: 1,
                                inv: 1,
                                isAffectKdv: 0
                            },
                            direction: -1,
                            percentage: 70,
                            priority:5,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0.13,
                            calculatedBy: "AMOUNT",
                            withholdingCode: "609",
                            allowanceReason: null,
                            calculateFrom:'withholdingCode',
                        }
                    ]
                }
            ]
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["masfed", "temfed"]
    },
    {
        gibType: eb,
        value: "IADE",
        label: "İade Fatura",
        invoiceTypeInfo: {
            documentTypeCode: "IADE",
            profileId: "EBELGE",
            accountingCost: null,
            retailCustomer: false
        },
        includePortalTypes: ["all"],
        excludePortalTypes: ["masfed", "temfed"]
    },
    {
        gibType: eb,
        value: "OZELMATRAH",
        label: "Özel Matrah Fatura",
        invoiceTypeInfo: {
            documentTypeCode: "OZELMATRAH",
            profileId: "EBELGE",
            accountingCost: null,
            retailCustomer: false
        },
        includePortalTypes: ["none"],
        excludePortalTypes: ["all"]
    },
    {
        gibType: ef,
        value: "ArabaSatısı",
        label: "Araç Satışı Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "OZELMATRAH",
            profileId: "TEMELFATURA",
            accountingCost: null,
            invoiceLines: [
            {
                recordId: null,
                itemCode: null,
                buyersItemIdentification: null,
                manufacturersItemIdentification: null,
                itemId: null,
                itemName: "Araç Satışı",
                barcode: null,
                quantity: 1,
                unit: "C62",
                unitPrice: 1,
                lineExtensionAmount: 1,
                trdDocInvoiceLineCharges: [
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 5,
                            code: "0000",
                            shortName: "İSKONTO",
                            longName: "İSKONTO",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: -1,
                            affectTaxableAmount: 1,
                            mm: 0,
                            smm: 0,
                            inv: 1,
                            isAffectKdv: 1
                        },
                        direction: -1,
                        percentage: 0,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 1,
                            code: "0015",
                            shortName: "KDV GERCEK",
                            longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            direction: 1,
                            calculatedBy: "AMOUNT",
                            priority: 4,
                            affectTaxableAmount: 0,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        direction: 1,
                        percentage: 0,
                        exemptionReason: "812-İkinci el motorlu kara taşıtı veya taşınmaz ticaretiyle iştigal eden mükelleflerce, KDV mükellefi olmayanlardan (mükellef olanlardan istisna kapsamında yapılan alımlar dâhil) alınarak vasfında esaslı değişiklik yapılmaksızın ikinci el motorlu kara taşıtı veya taşınmaz teslimi",
                        exemptionReasonCode: "812",
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    }
                ],
                trdDocInvoiceLineDeliveryDetail: null,
            },
            {
                recordId: null,
                itemCode: null,
                buyersItemIdentification: null,
                manufacturersItemIdentification: null,
                itemId: null,
                itemName: "Matrah",
                barcode: null,
                quantity: 1,
                unit: "C62",
                unitPrice: 1,
                lineExtensionAmount: 1,
                trdDocInvoiceLineCharges: [
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 5,
                            code: "0000",
                            shortName: "İSKONTO",
                            longName: "İSKONTO",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: -1,
                            affectTaxableAmount: 1,
                            mm: 0,
                            smm: 0,
                            inv: 1,
                            isAffectKdv: 1
                        },
                        direction: -1,
                        percentage: 0,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 1,
                            code: "0015",
                            shortName: "KDV GERCEK",
                            longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            direction: 1,
                            calculatedBy: "AMOUNT",
                            priority: 4,
                            affectTaxableAmount: 0,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        direction: 1,
                        percentage: 1,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0.01,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    }
                ],
                    trdDocInvoiceLineDeliveryDetail: null,
            }
            ]
        },
        includePortalTypes: ["masfed","smart"],
        excludePortalTypes: ["none"]
    },
    {
        gibType: ef,
        value: "PromosyonFatura",
        label: "Promosyon Bedeli Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "TEVKIFAT",
            profileId: "TEMELFATURA",
            accountingCost: null,
            invoiceLines: [{
                recordId: null,
                itemCode: null,
                buyersItemIdentification: null,
                manufacturersItemIdentification: null,
                itemId: null,
                itemName: "Promosyon Bedeli",
                barcode: null,
                quantity: 1,
                unit: "C62",
                unitPrice: 1,
                lineExtensionAmount: 1,
                trdDocInvoiceLineCharges: [
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 5,
                            code: "0000",
                            shortName: "İSKONTO",
                            longName: "İSKONTO",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: -1,
                            affectTaxableAmount: 1,
                            mm: 0,
                            smm: 0,
                            inv: 1,
                            isAffectKdv: 1
                        },
                        direction: -1,
                        percentage: 0,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 1,
                            code: "0015",
                            shortName: "KDV GERCEK",
                            longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            direction: 1,
                            calculatedBy: "AMOUNT",
                            priority: 4,
                            affectTaxableAmount: 0,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        direction: 1,
                        percentage: 20,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0.20,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    },
                    {
                            recordId: null,
                            taxCode: {
                                recordId: 6,
                                code: "9015",
                                shortName: "KDV TEVKİFATI",
                                longName: "KDV TEVKİFATI",
                                direction: -1,
                                calculatedBy: "AMOUNT",
                                priority: 5,
                                affectTaxableAmount: 0,
                                mm: 0,
                                smm: 1,
                                inv: 1,
                                isAffectKdv: 0
                            },
                            direction: -1,
                            percentage: 50,
                            priority:5,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0.09,
                            calculatedBy: "AMOUNT",
                            withholdingCode: "616",
                            allowanceReason: null,
                            calculateFrom:'withholdingCode',
                        }
                ],
                trdDocInvoiceLineDeliveryDetail: null,
            }
            ]
        },
        includePortalTypes: ["eczacikart", "kolaysoft"],
        excludePortalTypes: ["all"]
    },
    {
        gibType: ef,
        value: "KamuKurumIskonto",
        label: "Kamu Kurum İskontosu Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "TICARIFATURA",
            accountingCost: null,
            invoiceLines: [
            {
                recordId: null,
                itemCode: null,
                buyersItemIdentification: null,
                manufacturersItemIdentification: null,
                itemId: null,
                itemName: "Kamu Kurum İskontosu",
                barcode: null,
                quantity: 1,
                unit: "C62",
                unitPrice: 1,
                lineExtensionAmount: 1,
                trdDocInvoiceLineCharges: [
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 5,
                            code: "0000",
                            shortName: "İSKONTO",
                            longName: "İSKONTO",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: -1,
                            affectTaxableAmount: 1,
                            mm: 0,
                            smm: 0,
                            inv: 1,
                            isAffectKdv: 1
                        },
                        direction: -1,
                        percentage: 0,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 1,
                            code: "0015",
                            shortName: "KDV GERCEK",
                            longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            direction: 1,
                            calculatedBy: "AMOUNT",
                            priority: 4,
                            affectTaxableAmount: 0,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        direction: 1,
                        percentage: 10,
                        exemptionReason: null,
                        exemptionReasonCode: null,
                        taxableAmount: 1,
                        perUnitAmount: 0,
                        amount: 0.10,
                        calculatedBy: "AMOUNT",
                        withholdingCode: null,
                        allowanceReason: null,
                    }
                ],
                trdDocInvoiceLineDeliveryDetail: null,
            }
            ]
        },
        includePortalTypes: ["eczacikart", "kolaysoft"],
        excludePortalTypes: ["masfed", "temfed","esnaffatura"]
    },
    {
        gibType: ef,
        value: "ErkenOdemeIskonto",
        label: "Erken Ödeme İskontosu Fatura",
        invoiceTypeInfo: {
            invoiceTypeCode: "SATIS",
            profileId: "TEMELFATURA",
            accountingCost: null,
            invoiceLines: [
                {
                    recordId: null,
                    itemCode: null,
                    buyersItemIdentification: null,
                    manufacturersItemIdentification: null,
                    itemId: null,
                    itemName: "Erken Ödeme İskontosu",
                    barcode: null,
                    quantity: 1,
                    unit: "C62",
                    unitPrice: 1,
                    lineExtensionAmount: 1,
                    trdDocInvoiceLineCharges: [
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 5,
                                code: "0000",
                                shortName: "İSKONTO",
                                longName: "İSKONTO",
                                direction: -1,
                                calculatedBy: "AMOUNT",
                                priority: -1,
                                affectTaxableAmount: 1,
                                mm: 0,
                                smm: 0,
                                inv: 1,
                                isAffectKdv: 1
                            },
                            direction: -1,
                            percentage: 0,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0,
                            calculatedBy: "AMOUNT",
                            withholdingCode: null,
                            allowanceReason: null,
                        },
                        {
                            recordId: null,
                            taxCode: {
                                recordId: 1,
                                code: "0015",
                                shortName: "KDV GERCEK",
                                longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                                direction: 1,
                                calculatedBy: "AMOUNT",
                                priority: 4,
                                affectTaxableAmount: 0,
                                mm: 0,
                                smm: 1,
                                inv: 1,
                                isAffectKdv: 0
                            },
                            direction: 1,
                            percentage: 10,
                            exemptionReason: null,
                            exemptionReasonCode: null,
                            taxableAmount: 1,
                            perUnitAmount: 0,
                            amount: 0.10,
                            calculatedBy: "AMOUNT",
                            withholdingCode: null,
                            allowanceReason: null,
                        }
                    ],
                    trdDocInvoiceLineDeliveryDetail: null,
                }
            ]
        },
        includePortalTypes: ["eczacikart", "kolaysoft"],
        excludePortalTypes: ["masfed", "temfed","esnaffatura"]
    }
];